<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content bg-olf-isabelline mb-0">
                <div class="modal-header">
                    <h1 class="heading-large">Accept Negotiation</h1>
                    <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>
                <div v-if="!showSaleConfirmed">
                    <!-- Seller info -->
                    <div class="modal-body seller-info pt-0">
                        <h2 class="heading-medium">
                            <span v-if="negotiationToAccept.buyer">
                                {{negotiationToAccept.buyer.firstName + ' ' + negotiationToAccept.buyer.lastName}}
                            </span>
                            <span v-else>{{negotiationToAccept.createdby_id}}</span>
                        </h2>
                        <span v-if="getNegotiationListActiveStatus[activeTabIndex - 1]" class="negotiation-countdown timer-displaying">
                            <span class="text-display">{{getNegotiationListTimer[activeTabIndex - 1] | countdownshortformat}}</span>
                            <radial-progress-bar class="countdown-progress" :diameter="35" 
                                :totalSteps="parseInt((new Date(negotiationToAccept.expires) - new Date(negotiationToAccept.created))/1000)" 
                                :completedSteps="getNegotiationListTimer[activeTabIndex - 1]" />
                        </span>
                    </div>

                    <!-- Order details -->
                    <div class="modal-body order-details bg-white">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Product</label>
                                <div>{{negotiationToAccept.fuel_id | fueltype}}</div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Price (ppl)</label>
                                <div class="price" :class="{'changed': (negotiationToAccept.type_id == 'TRACKING' ?
                                    (negotiationToAccept.livePrice !== initialNegotiationDetails.livePrice) : 
                                    (negotiationToAccept.price !== initialNegotiationDetails.price))}">
                                    {{negotiationToAccept.type_id == 'TRACKING' ?
                                        negotiationToAccept.livePrice : negotiationToAccept.price | priceformat}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Buyer</label>
                                <div v-if="negotiationToAccept.buyer">
                                    {{negotiationToAccept.buyer.firstName + ' ' + negotiationToAccept.buyer.lastName}}
                                </div>
                                <div v-else>N/A</div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Volume/L</label>
                                <div :class="{'changed': negotiationToAccept.quantity !== initialNegotiationDetails.quantity}">{{negotiationToAccept.quantity | volumeformat}}</div>
                            </div>
                        </div>
                        <div v-if="negotiationType !== 'BUNKERING'" class="row">
                            <div v-if="negotiationType == 'SPOT'" class="col-md-6">
                                <label class="mb-0">Terminal</label>
                                <div v-if="negotiationToAccept.terminal">
                                    <span :class="{'changed': negotiationToAccept.terminal._id !== initialNegotiationDetails.terminal._id}">{{negotiationToAccept.terminal.name}}</span>
                                </div>
                                <div v-else>N/A</div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Lifting Period</label>
                                <div :class="{'changed': negotiationToAccept.collectionTime !== initialNegotiationDetails.collectionTime}">{{negotiationToAccept.collectionTime | collectiondaysformat}}</div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Measurement</label>
                                <div :class="{'changed': negotiationToAccept.fuel_measurement_id !== initialNegotiationDetails.fuel_measurement_id}">{{negotiationToAccept.fuel_measurement_id | fuelmeasurementtype}}</div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="mb-0">Payment Terms</label>
                                <div v-if="negotiationToAccept.buyer">{{negotiationToAccept.buyer.credit.days | creditdaysformat}}</div>
                                <div v-else>N/A</div>
                            </div>
                        </div>
                        <div class="row reference">
                            <div class="col-md-12">
                                <template v-if="negotiationType !== 'BUNKERING'">
                                    <label class="mb-0 mr-2">Reference</label>
                                    <span :class="{'changed': negotiationToAccept.reference !== initialNegotiationDetails.reference}">
                                        {{negotiationToAccept.reference}}
                                    </span>
                                </template>
                                <template v-else>
                                    <label class="mb-0 mr-2">Keyfuels/UK Fuels account number</label>
                                    <div :class="{'changed': negotiationToAccept.reference !== initialNegotiationDetails.reference}">
                                        {{negotiationToAccept.reference}}
                                    </div>                                  
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Total volume and price -->
                    <div class="modal-body total bg-olf-light-grey">
                        <div class="row">
                            <div class="col-md-6">
                                TOTAL
                            </div>
                            <div class="col-md-6">
                                <div class="d-flex justify-content-between">
                                    <span :class="{'changed': negotiationToAccept.quantity !== initialNegotiationDetails.quantity}">
                                        {{negotiationToAccept.quantity | volumeformat}} Litres
                                    </span>
                                    <span :class="{'changed': (negotiationToAccept.quantity * (negotiationToAccept.type_id == 'TRACKING' ?
                                            negotiationToAccept.livePrice : negotiationToAccept.price)/100) !== (initialNegotiationDetails.quantity * (initialNegotiationDetails.type_id == 'TRACKING' ?
                                            initialNegotiationDetails.livePrice : initialNegotiationDetails.price)/100)}">
                                        £{{negotiationToAccept.quantity * 
                                            (negotiationToAccept.type_id == 'TRACKING' ?
                                            negotiationToAccept.livePrice : negotiationToAccept.price)/100 | priceformat}}
                                    </span>
                                </div>

                                <!-- CREDIT LINE SELECTION -->
                                <div v-if="creditLineSelectionRequired" class="mt-2" :class="{ 'd-flex justify-content-between': $breakpoint.mdAndUp }">
                                    <label 
                                        class="align-self-center" 
                                        :class="[$breakpoint.mdAndUp ? 'w-50' : 'd-block w-100', { 'text-danger': errorId === 'CREDIT_LINE' }]"
                                    >Credit Line</label>
                                    <div class="select-wrapper" :class="$breakpoint.mdAndUp ? 'w-50' : 'd-block w-100'">
                                        <select v-model="brandSelected" :class="{'border-danger': errorId === 'CREDIT_LINE'}" @change="checkErrors()">
                                            <option :value="brand" v-for="(brand, index) in brandSelection" :key="index" :disabled="!brand">
                                                <span v-if="brand">{{ brand.name }}</span>
                                                <span v-else>Select a credit line</span>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer d-flex justify-content-end">
                        <span class="error-message">{{error}}</span>
                        <button class="btn btn-primary ml-0" :disabled="error || isPlacingOrder" @click="confirmSale($event)">
                            <span v-if="isPlacingOrder">Processing...</span>
                            <span v-else>Confirm Sale</span>
                        </button>
                    </div>
                </div>

                <!-- Confirmation screen after placing order -->
                <div v-else>
                    <div class="modal-body confirmation text-center">
                        <h1 class="mb-3">{{saleStatusMessage}}</h1>
                        <router-link to="/OrderHistory/all" class="btn btn-primary" tag="button" v-on:click.native="toPurchaseHistory">
                            Go to order history
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data(){
        return {
            input: {
                notes: ''
            },
            isPlacingOrder: false,
            initialNegotiationDetails: '',
            timeoutFunction: '',
            creditLineSelectionRequired: false,
            brandSelection: [],
            brandSelected: null,
            errorId: ""
        }
    },
    created() {
        this.updateShowSaleConfirmed(false)
        this.input.orderReference = this.fuelGroupSelected.negotiationList[this.activeTabIndex - 1].reference
        this.updateInitialNegotiation()
        
        const accountDetails = this.$store.getters['accounts/accountDetails'];
        
        if (accountDetails && accountDetails.brands && accountDetails.brands.length > 0){
            this.brandSelection = [null, ...accountDetails.brands];
            this.creditLineSelectionRequired = true;
        } else {
            this.creditLineSelectionRequired = false;
        }
    },
    computed: {
        ...mapGetters('fuelsType', ['getFuelsType']),
        ...mapState('negotiation', ['fuelGroupSelected', 'activeTabIndex', 'showSaleConfirmed', 'saleStatusMessage']),
        ...mapGetters('negotiation', ['getNegotiationListTimer', 'getNegotiationListActiveStatus']),
        negotiationToAccept: {
            get: function(){
                if (this.fuelGroupSelected){
                    this.timeoutFunction = ''
                    this.timeoutFunction = setTimeout(() => {
                        this.updateInitialNegotiation()
                    }, 5000)
                    return this.fuelGroupSelected.negotiationList[this.activeTabIndex - 1]
                }
            }
        },
        error: {
            get: function(){
                if (!this.getNegotiationListActiveStatus[this.activeTabIndex - 1]){
                    return 'Negotiation has either expired, been cancelled or accepted'
                }
            }
        },
        negotiationType: {
            get: function(){
                if (this.getFuelsType.length > 0 && this.negotiationToAccept){
                    const fuel = this.getFuelsType.find(fuel => fuel._id == this.negotiationToAccept.fuel_id)
                    return fuel.type
                }
            }
        }
    },
    methods: {
        ...mapActions('negotiation', ['updateShowAcceptNegotiation', 'acceptNegotiationConfirmed', 'updateShowSaleConfirmed',
            'checkNegotiationAvailability', 'showNegotiationUnavailableWindow']),
        closeModal: function(){
            $(this.$el).modal('hide')
            this.updateShowSaleConfirmed(false)
            this.updateShowAcceptNegotiation(false)
        },
        toPurchaseHistory: function(event){
            event.preventDefault()
            $(this.$el).modal('hide')
            this.updateShowSaleConfirmed(false)
            this.updateShowAcceptNegotiation(false)
        },
        updateInitialNegotiation: function(){
            this.initialNegotiationDetails = this.fuelGroupSelected.negotiationList[this.activeTabIndex - 1]
        },
        checkErrors: function(){
            if (this.creditLineSelectionRequired && !this.brandSelected){
                this.errorId = "CREDIT_LINE";
            } else {
                this.errorId = null;
            }
        },
        confirmSale: async function(event){
            this.isPlacingOrder = true;

            if (this.creditLineSelectionRequired && !this.brandSelected){
                await this.checkErrors();
                if (this.errorId) return this.isPlacingOrder = false;
            }
            
            const negotiationAvailable = await this.checkNegotiationAvailability({negotiationId: this.negotiationToAccept._id})

            /* Check whether negotiation is still active or not */
            if (negotiationAvailable){
                const payload = {
                    negotiation_id: this.negotiationToAccept._id
                };

                if (this.brandSelected) payload.brandId = this.brandSelected._id;

                await this.acceptNegotiationConfirmed(payload)
            }
            else {
                this.showNegotiationUnavailableWindow(true)
                this.closeModal()
            }
        }
    },
    beforeDestroy(){
        clearTimeout(this.timeoutFunction)
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";
</style>